var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3539 6.14713L15.3534 11.1466C15.3999 11.193 15.4368 11.2482 15.4619 11.3089C15.4871 11.3696 15.5 11.4346 15.5 11.5003C15.5 11.566 15.4871 11.6311 15.4619 11.6918C15.4368 11.7525 15.3999 11.8076 15.3534 11.854L10.3539 16.8535C10.2601 16.9473 10.1329 17 10.0002 17C9.86756 17 9.74032 16.9473 9.64651 16.8535C9.5527 16.7597 9.5 16.6324 9.5 16.4998C9.5 16.3671 9.5527 16.2399 9.64651 16.1461L14.2929 11.5003L9.64651 6.85456C9.60006 6.80811 9.56322 6.75296 9.53808 6.69227C9.51294 6.63158 9.5 6.56653 9.5 6.50084C9.5 6.43515 9.51294 6.37011 9.53808 6.30942C9.56322 6.24873 9.60006 6.19358 9.64651 6.14713C9.69296 6.10068 9.74811 6.06384 9.8088 6.0387C9.86949 6.01356 9.93453 6.00062 10.0002 6.00062C10.0659 6.00062 10.131 6.01356 10.1917 6.0387C10.2523 6.06384 10.3075 6.10068 10.3539 6.14713Z",
    fill: "#60666C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDisabled);
export default __webpack_public_path__ + "static/media/right-disabled.9457ba81b3a42a78efc903db56cf1e0a.svg";
export { ForwardRef as ReactComponent };